export const homeExamples = [
  {
    text: "A triple-glazed curtain wall facade with pile foundations and steel supports.",
    carbon: "3102.74 kgCO2e/sq.m",
  },
  {
    text: "A timber-framed house with a green roof and sheep's wool insulation.",
    carbon: "230.43 kgCO2e/sq.m",
  },
  {
    text: "A 15-storey high-rise with a reinforced concrete frame and masonry curtain wall, rising tall.",
    carbon: "1528.82 kgCO2e/sq.m",
  },
  {
    text: "A prefabricated modular building with steel framing and SIP panels, for quick assembly.",
    carbon: "2385.99 kgCO2e/sq.m",
  },
  {
    text: "A clay or mud building with thick masonry block walls, rooted in vernacular tradition.",
    carbon: "496.61 kgCO2e/sq.m",
  },
];

export const insightExamples = [
  {
    title: "Suburban housing",
    brief:
      "A two-storey semi-detached house with a timber frame, brick cladding and a pitched tile roof.",
  },
  {
    title: "Mid-rise office",
    brief:
      "A six-storey office with a reinforced concrete frame, curtain-wall glazing and a flat roof.",
  },
  {
    title: "High-rise residential",
    brief:
      "A fifteen-storey apartment block with a concrete core, precast facade panels and triple-glazed windows.",
  },
  {
    title: "Modular school",
    brief:
      "A single-storey primary school with cross-laminated timber walls, SIP roof panels and a green roof.",
  },
  {
    title: "Warehouse / logistics",
    brief:
      "A steel-portal-frame distribution warehouse with profiled-metal cladding and an asphalt-membrane roof.",
  },
  {
    title: "Cultural / civic",
    brief:
      "A museum with an exposed glulam roof structure, masonry walls and a large glazed entrance facade.",
  },
  {
    title: "Vernacular dwelling",
    brief:
      "A single-storey rammed-earth house with thick masonry walls, timber joists and a clay-tile roof.",
  },
  {
    title: "Retail store",
    brief:
      "A two-storey retail store with masonry brick walls, ceramic tile flooring and a steel-framed roof.",
  },
  {
    title: "Community centre",
    brief:
      "A clay block and concrete community centre with a sloped roof, softwood frames and natural ventilation.",
  },
  {
    title: "High-rise curtain wall",
    brief:
      "A triple-glazed curtain wall high-rise with pile foundations, steel supports and a reinforced concrete core.",
  },
];

export const heroShortExamples = [
  {
    short: "Timber-framed semi with a tiled roof.",
    long: "A two-storey semi-detached house with a timber frame, brick cladding and a pitched clay-tile roof.",
  },
  {
    short: "Steel-frame warehouse, metal cladding.",
    long: "A single-storey steel-portal-frame distribution warehouse with profiled-metal cladding and an asphalt-membrane roof.",
  },
  {
    short: "Concrete-frame office, curtain wall.",
    long: "A six-storey office with a reinforced concrete frame, curtain-wall glazing and a flat roof.",
  },
  {
    short: "CLT primary school, green roof.",
    long: "A single-storey primary school with cross-laminated timber walls, SIP roof panels and a green roof.",
  },
  {
    short: "Brick terrace with timber joists.",
    long: "A three-storey brick terrace with masonry party walls, timber joist floors and a slate-tile pitched roof.",
  },
  {
    short: "Glulam museum, masonry walls.",
    long: "A museum with an exposed glulam roof structure, masonry walls and a large glazed entrance facade.",
  },
  {
    short: "Rammed-earth house, clay-tile roof.",
    long: "A single-storey rammed-earth house with thick masonry walls, timber joists and a clay-tile roof.",
  },
  {
    short: "Modular steel pods, SIP panels.",
    long: "A prefabricated modular building with steel framing, SIP wall and roof panels and quick on-site assembly.",
  },
  {
    short: "High-rise core with precast facade.",
    long: "A fifteen-storey apartment block with a reinforced concrete core, precast facade panels and triple-glazed windows.",
  },
  {
    short: "Two-storey retail, masonry walls.",
    long: "A two-storey retail store with masonry brick walls, ceramic tile flooring and a steel-framed roof.",
  },
];

export const insightExampleInputs = insightExamples.map((example) => example.brief);

export const insightPlaceholders = [
  "Describe your building — materials, structure, scale…",
  "What are you designing today?",
  "e.g. A 12-storey office with glulam beams and curtain wall glazing",
  "More detail improves prediction accuracy",
];
